import React, {Component} from 'react';
import PropTypes from "prop-types";

class ErrorPageContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    static defaultProps = {
        code: 404,
    };

    static statusCodes = {
        401: 'Unauthorized access.',                    //  Unautorisierter Zugriff.
        404: 'The requested resource was not found.',   //  Die angeforderte Ressource wurde nicht gefunden.
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    getStatusMsg(code = null) {

        if (!code) return this.translate('httpCode404');

        let status = this.translate('httpCode' + code);

        if (status === null) status = this.translate('httpCode404');

        return status;

    }

    render() {

        let code = this.props.code;
        let description = this.getStatusMsg(code);

        return (
            <div className="ErrorPageContainer">
                <nav>
                    <h1>{this.translate('error')} {this.props.code}</h1>
                </nav>

                <div>
                    <p>{description}</p>
                </div>
            </div>
        );

    }

}

export default ErrorPageContainer;